import { render, staticRenderFns } from "./ReferralsContainer.vue?vue&type=template&id=2b943850"
import script from "./ReferralsContainer.vue?vue&type=script&lang=js"
export * from "./ReferralsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports